import React, { createContext, useState } from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import AboutUsPage from './components/AboutUs/AboutUsPage.js';
import CategoryPage from './components/Categories/CategoryPage.js';
import CollectionOfCategoryPage from './components/Categories/CollectionOfCategoryPage.js';
import ContactPage from './components/Contact/ContactPage.js';
import GalleryPage from './components/Gallery/GalleryPage.js';
import Home from './components/Home/Home.js';
import SingleProductPage from './components/SingleProductPage/SingleProductPage.js';
import TestimonialPage from './components/Testimonial/TestimonialPage.js';
import CartListPage from './components/CartList/CartListPage.js';
import VerticalLineStepperPage from './components/VerticalLinearStepper/VerticalLineStepperPage.js';
import PaymentSuccess from './components/Payment/PaymentSuccess.js';
import TrackOrderPage from './components/TrackOrderPage/TrackOrderPage.js';
import Login from './components/Signup/Login.js';
import MyorderPage from './components/Myorder/MyorderPage.js';
import MywhishlistPage from './components/Mywhishlist/MywhishlistPage.js';
import PrivateRoute from './components/PrivateRoute/PrivateRoute.js';
import useCaseFirebase from './components/Firebase/useCaseFirebase.js';
import SignUp from './components/Signup/Signup.js';
import CheckyourEmail from './components/Signup/CheckyourEmail.js';

export const collectionContext = createContext()


const App = () => {

  const [cartData, setCartData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [recentKey, setRecentKey] = useState([]);
  const [searchItem, setSearchItem] = useState([]);
  const [page, setPage] = useState(1);
  const [searchLoading, setSearchLoading] = useState(false);
  const firebaseContext = useCaseFirebase();
  return (

    <collectionContext.Provider value={{
      value1: [cartData, setCartData],
      value2: [refresh, setRefresh],
      value3: [recentKey, setRecentKey],
      value4: [searchItem, setSearchItem],
      value5: [page, setPage],
      value6: [searchLoading, setSearchLoading],
      value7: firebaseContext

    }} >
      <div className="app" id="home">
        <Routes>
          <Route path="/" element={<Home refresh={refresh} />} />
          <Route path="/singleProduct/:type/:id" element={<SingleProductPage />} />
          <Route path="/categories/:type" element={<PrivateRoute><CollectionOfCategoryPage /></PrivateRoute>} />
          <Route path="/search-item/:searchValue" element={<CollectionOfCategoryPage />} />
          <Route path="/categories" element={<CategoryPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/testimonial" element={<TestimonialPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/reviewList" element={<CartListPage />} />
          <Route path="/checkout" element={<PrivateRoute><VerticalLineStepperPage /></PrivateRoute>} />
          <Route path="/success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
          <Route path="/track-order/:trackId/:orderId" element={<PrivateRoute><TrackOrderPage /></PrivateRoute>} />
          <Route path="/my-orders" element={<PrivateRoute><MyorderPage /></PrivateRoute>} />
          <Route path="/my-whishlist" element={
            <PrivateRoute><MywhishlistPage /></PrivateRoute>
          } />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
           <Route path="/check-email/:email" element={<CheckyourEmail />} />
        </Routes>
      </div>
    </collectionContext.Provider>

  );
};

export default App;